import { render, staticRenderFns } from "./ManagementTabs.vue?vue&type=template&id=4fbcdcb8&"
import script from "./ManagementTabs.vue?vue&type=script&lang=js&"
export * from "./ManagementTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports